import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-3">
        <img
          src={comic.cover}
          alt={`${comic.title} - 羞羞漫画正版授权`}
          title={`${comic.title} - 羞羞漫画在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-2.5">
          <div className="flex items-center gap-1.5 mb-1">
            <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-50">
              {comic.status}
            </span>
            {comic.isNew && (
              <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50">
                NEW
              </span>
            )}
            {comic.isHot && !comic.isNew && (
              <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-red-500 text-white">
                HOT
              </span>
            )}
          </div>
        </div>
        <div className="absolute top-2 right-2">
          <span className="flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-black/40 text-white text-[11px]">
            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
            {comic.rating}
          </span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 line-clamp-1">{comic.author} · 共{comic.chapters}话</p>
    </Link>
  );
}